
import actionTypes from './actionTypes';

export const openModal = (value) => ({
    type: actionTypes.MODAL_OPEN,
    newValue: value
});

export const closeModal = () => ({
    type: actionTypes.MODAL_CLOSE
});

